const getters = {

  projectIsLive: (state) => state.id !== process.env.VUE_APP_LOCAL_PROJECT_ID

}

export default getters
